import { render, staticRenderFns } from "./KisiKurumForm.vue?vue&type=template&id=69a33972"
import script from "./KisiKurumForm.vue?vue&type=script&lang=ts"
export * from "./KisiKurumForm.vue?vue&type=script&lang=ts"
import style0 from "./KisiKurumForm.vue?vue&type=style&index=0&id=69a33972&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports